import { atom } from 'jotai';

import type { IOption } from '@/types';

import type { ExampleCompany } from '../explore.state';

export const regenerateExploreFormDescriptionState = atom<string>('');

export const regenerateExploreFormLocationsState = atom<IOption[]>([]);

export const regenerateExploreFormExampleCompaniesState = atom<
  ExampleCompany[]
>([]);

export const isRegeneratePanelOpenState = atom<boolean>(false);
